import { CarFront, Home, MessageCircle, User, Wallet } from "lucide-react";

export const NAV = [
  { value: "home", label: "Home", icon: Home },
  { value: "rides", label: "My Rides", icon: CarFront },
  { value: "credit", label: "Ride Credit", icon: Wallet },
  { value: "messages", label: "Messages", icon: MessageCircle },
  { value: "profile", label: "Profile", icon: User },
];

export function BottomNav({ value, onChange, items = NAV, testid = "rider-bottom-nav" }) {
  return (
    <nav className="glass fixed inset-x-0 bottom-0 z-50 border-t border-white/10 pb-[env(safe-area-inset-bottom)]" data-testid={testid}>
      <div className="mx-auto grid max-w-2xl" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map(({ value: v, label, icon: Icon }) => {
          const on = value === v;
          return (
            <button key={v} type="button" onClick={() => onChange(v)} data-testid={`nav-${v}`} aria-current={on ? "page" : undefined}
              className={`flex min-h-[60px] flex-col items-center justify-center gap-1 px-0.5 text-center ${items.length > 5 ? "text-[10px]" : "text-[11px]"} font-semibold leading-tight transition-colors ${on ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}>
              <Icon className={`h-5 w-5 ${on ? "drop-shadow-[0_0_8px_hsl(var(--primary)/0.7)]" : ""}`} />
              {label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export function Segmented({ options, value, onChange, testid }) {
  return (
    <div className="flex gap-1 rounded-full bg-muted p-1" data-testid={testid}>
      {options.map((o) => (
        <button key={o.value} type="button" onClick={() => onChange(o.value)} data-testid={`${testid}-${o.value}`}
          className={`flex-1 rounded-full px-3 py-2.5 text-sm font-bold tracking-wide transition-colors ${value === o.value ? "bg-primary text-primary-foreground shadow-[0_0_14px_hsl(var(--primary)/0.45)]" : "text-muted-foreground hover:text-foreground"}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

export const SectionTitle = ({ children, action }) => (
  <div className="flex items-center justify-between">
    <h2 className="text-[11px] font-bold uppercase tracking-[0.2em] text-muted-foreground">{children}</h2>
    {action}
  </div>
);
